var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepCardWrapper"},[_c('div',{staticClass:"stepImage"},[_c('img',{attrs:{"src":_vm.imageSource,"alt":""}})]),_c('div',{staticClass:"paragraph"},_vm._l((_vm.fields),function(field){return _c('p',{key:field.fieldId},[_c('componentRenderer',{key:field.id,attrs:{"field":field}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }